import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { NewservicerequestPage } from '../newservicerequest/newservicerequest';
import { ServicehistoryPage } from '../servicehistory/servicehistory';
/**
 * Generated class for the ServiceRequestPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-service-request',
  templateUrl: 'service-request.html',
})
export class ServiceRequestPage {
  tab1Root:any=NewservicerequestPage
  tab2Root:any=ServicehistoryPage
  loanstatus:boolean=true
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    if(this.navParams.data.loanParameterDetail.responseParameters[0].loanstatus=='Active'){
      this.loanstatus=false
    }
    //console.log('ionViewDidLoad ServiceRequestPage,',this.navParams);
  }

}



// WEBPACK FOOTER //
// ./src/pages/service-request/service-request.ts